import { createToast } from 'mosha-vue-toastify'
import 'mosha-vue-toastify/dist/style.css'

export default function Flash(i18n) {
    this.config = {
        timeout: 3000,
        hideProgressBar: true,
        showIcon: true,
    }

    this.success = (messages) => {
        if (typeof messages === 'string') {
            createToast({ title: i18n.global.t('basic.alert.success'), description: messages}, { ...this.config, type: 'success'})
        }
    }

    this.error = (messages) => {
        if (typeof messages === 'string') {
            createToast({ title: i18n.global.t('basic.alert.failed'), description: messages}, { ...this.config, type: 'danger'})
        }
    }
}